import React, { useState } from "react";

const LifecycleStep = ({ num, title, desc, color, isActive }) => {
    return (
        <div style={{
            flex: "1", minWidth: "280px", padding: "50px 40px",
            background: isActive ? "rgba(255,255,255,0.03)" : "transparent",
            border: `1px solid ${isActive ? color : 'rgba(255,255,255,0.06)'}`,
            borderRadius: "4px", position: "relative", transition: "all 0.5s cubic-bezier(0.2, 0.8, 0.2, 1)",
            opacity: isActive ? 1 : 0.3, transform: isActive ? "scale(1.05)" : "scale(1)",
            zIndex: isActive ? 10 : 1
        }}>
            {/* Phase Indicator */}
            <div style={{ 
                position: "absolute", top: "25px", right: "25px", 
                fontSize: "10px", color: color, fontFamily: "monospace", letterSpacing: "2px"
            }}>PHASE_L{num}</div>
            
            <div style={{ 
                width: "45px", height: "45px", borderRadius: "50%", 
                background: isActive ? color : "rgba(255,255,255,0.05)",
                marginBottom: "30px", display: "flex", alignItems: "center", justifyContent: "center",
                color: isActive ? "#000" : "rgba(255,255,255,0.2)", fontWeight: "900",
                boxShadow: isActive ? `0 0 20px ${color}` : "none", transition: "all 0.3s"
            }}>{num}</div>

            <h4 style={{ color: "#fff", fontFamily: "'Conthrax', sans-serif", fontSize: "17px", marginBottom: "20px", letterSpacing: "1px" }}>{title}</h4>
            <p style={{ color: "rgba(255,255,255,0.45)", fontSize: "14px", lineHeight: 1.8, fontWeight: "300" }}>{desc}</p>
            
            {/* Status Signal */}
            {isActive && (
                <div style={{ 
                    marginTop: "30px", fontSize: "9px", color: color, 
                    fontFamily: "monospace", display: "flex", alignItems: "center", gap: "10px" 
                }}>
                    <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: color, animation: "blink 1s infinite" }} />
                    PROCESSED_LINK_ACTIVE
                </div>
            )}
        </div>
    );
};

function Portfolio({ content }) {
  const { color, id } = content;
  const [activeStep, setActiveStep] = useState(1);

  const steps = content.lifecycle || [];

  return (
    <section id="lifecycle" style={{
      padding: "180px 30px", background: "#010108", position: "relative", overflow: "hidden"
    }}>
      <style>{`
        @keyframes lineFlow { 0% { background-position: 0 0; } 100% { background-position: 100% 0; } }
        .flow-line {
            position: absolute; top: 62%; left: 0; width: 100%; height: 2px;
            background: linear-gradient(90deg, transparent, ${color}, transparent, ${color}, transparent);
            background-size: 200% 100%;
            animation: lineFlow 10s linear infinite;
            opacity: 0.15; z-index: 0;
        }
      `}</style>

      {/* Background Energy Flow */}
      <div className="flow-line" />

      <div style={{ maxWidth: "1600px", margin: "0 auto", position: "relative", zIndex: 1 }}>
        <div style={{ textAlign: "center", marginBottom: "120px" }}>
            <span style={{ fontSize: "12px", color: color, fontFamily: "monospace", letterSpacing: "6px", fontWeight: "bold" }}>OPERATIONAL_LIFECYCLE</span>
            <h2 style={{ 
                fontSize: "clamp(35px, 5.5vw, 75px)", fontFamily: "'Conthrax', sans-serif", 
                color: "#fff", marginTop: "30px", textTransform: "uppercase", letterSpacing: "-2px"
            }}>Mission <span style={{ color: color }}>Continuity</span></h2>
            <p style={{ color: "rgba(255,255,255,0.35)", maxWidth: "700px", margin: "25px auto", fontFamily: "monospace", fontSize: "14px" }}>
                >> MAPPING THE END-TO-END INTELLIGENCE FLOW FOR {id.toUpperCase()} OPERATIONS...
            </p>
        </div>

        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", justifyContent: "center", padding: "0 20px" }}>
          {steps.map((s, i) => (
            <div key={i} onMouseEnter={() => setActiveStep(i+1)} style={{ flex: "1", minWidth: "280px" }}>
                <LifecycleStep 
                    num={i+1} 
                    title={s.title.toUpperCase()} 
                    desc={s.desc} 
                    color={color} 
                    isActive={activeStep === i+1} 
                />
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Portfolio;
